import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import Moment from "react-moment";
import { Box, Grid, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { setAlert } from "../../../../action/alert";
import Alert from "../../../layout/Alert";
import "./DeviceDACLogs.css";
import { format } from "date-fns";
import { dacStatsPageSize } from "../DACStatisticsConstants";


const DeviceDACLogs = ({
    deviceDetails,
    dacData = [],
    getDeviceDACLogsData,
    showSearch = false,
    showCount = false
}) => {

    const [deviceDACLogsData, setDeviceDACLogsData] = useState([]);
    const [updateFlag, setUpdateFlag] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [macAddress, setMacAddress] = useState("");

    const headers = {
        serialNumber: "S.No",
        timestamp: 'Created At'
    };

    // useEffect(() => {
    //     filter()
    // }, [])

    useEffect(() => {
        if (deviceDetails && deviceDetails instanceof Object && deviceDetails.hasOwnProperty('macAddress')) {
            getDeviceDACLogs()
        }
    }, [deviceDetails])

    useEffect(() => {
        if (updateFlag) {
            getDeviceDACLogs()
        }
    }, [updateFlag])

    useEffect(() => {
        setDeviceDACLogsData(dacData)
    }, [dacData])

    const filter = () => {
        setUpdateFlag(Math.random());
    }

    const getNextPage = () => {
        const newPg = pageIndex + 1
        setPageIndex(newPg);
        setIsLoading(true)
        getDeviceDACLogsData({
            macAddress,
            //pagination not yet implemented in API, check if param names are correct after implementation
            pgIndex: newPg,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }

    const getPrevPage = () => {
        const newPg = pageIndex - 1;
        setPageIndex(newPg);
        setIsLoading(true)
        getDeviceDACLogsData({
            macAddress,
            //pagination not yet implemented in API, check if param names are correct after implementation
            pgIndex: newPg,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }
    const getDeviceDACLogs = () => {
        setIsLoading(true)
        getDeviceDACLogsData({ macAddress: deviceDetails?.macAddress ?? "" }, () => {
            setIsLoading(false);
        })
    }

    const searchDACLogs = () => {
        setIsLoading(true)
        setPageIndex(0);
        getDeviceDACLogsData({
            macAddress,
            //pagination not yet implemented in API, check if param names are correct after implementation
            pgIndex: 0,
            pgSize: dacStatsPageSize
        }, () => {
            setIsLoading(false)
        })
    }

    return (
        <Fragment>
            {showSearch && (
                <Box className="content-block bottom-shadow dac-logs-filter">
                    <Box className="py-15 dac-logs-filter-row">
                        <TextField
                            size="small"
                            placeholder="Enter MAC address"
                            value={macAddress}
                            onChange={(e) => setMacAddress(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            className="dac-logs-filter-input"
                        />
                        <button
                            type="button"
                            className="btn btn-style-2 orange-bg dac-logs-filter-btn"
                            onClick={() => searchDACLogs()}
                            disabled={macAddress === ""}
                        >
                            Filter
                        </button>
                    </Box>
                </Box>
            )}
            <Alert />

            {isLoading ?
                <div
                    style={{
                        display: "grid",
                        placeItems: "center",
                        height: "80vh",
                    }}
                >
                    <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
                </div>
                :
                <div>
                    {showCount && (
                        <Box className="content-block bottom-shadow dac-logs-count-block">
                            <Box className="page-title dac-logs-count-title">
                                <Box component="h3" sx={{ m: 0 }}>{`DAC Count : ${dacData?.length || "-"}`}</Box>
                            </Box>
                        </Box>
                    )}
                    <Box className="content-block bottom-shadow py-15 mb-30">
                        <Grid container>
                            <Grid item xs={12}>
                                <Box className="table-wrapper mb-20" sx={{ overflow: "auto", maxHeight: "unset" }}>
                                    <table
                                        width="100%"
                                        align="center"
                                        className="table style-4 mb-20 deviceDACLogsTable"
                                    >
                                        <thead
                                            style={{ position: "sticky", top: 0, zIndex: 50, background: "white" }}
                                        >
                                            <tr>
                                                {Object.keys(headers).map((key, i) => (
                                                    <th key={i}>{headers[key]}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deviceDACLogsData && deviceDACLogsData.length === 0 ? (
                                                <tr>
                                                    <td colSpan={Object.keys(headers).length}>
                                                        No Data found
                                                    </td>
                                                </tr>
                                            ) : (
                                                deviceDACLogsData && deviceDACLogsData.length > 0 && deviceDACLogsData.map((element, index) => {
                                                    return (
                                                        <tr key={index} id={index}>
                                                            {Object.keys(headers).map((key, i) => {
                                                                return (
                                                                    key==="serialNumber" ?
                                                                        <td key={i} className={String(element[index]).length > 60 ? "breakWord" : ""}>
                                                                            {index + 1}
                                                                        </td>
                                                                        :
                                                                        <td key={i} className={String(element[index]).length > 200 ? "breakWord" : ""}>
                                                                            {
                                                                                format(new Date(Number(element)), "dd MMM yyyy, hh:mm a")
                                                                            }
                                                                        </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </Box>
                                {/* uncomment for pagination
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <button
                                        className="btn btn-style-2 orange-bg"
                                        style={{ marginRight: "12px" }}
                                        onClick={() => getPrevPage()}
                                        disabled={pageIndex === 0}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        className="btn btn-style-2 orange-bg"
                                        onClick={() => getNextPage()}
                                        disabled={dacData?.length < dacStatsPageSize}
                                    >
                                        Next
                                    </button>
                                </div> */}
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            }
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    setCustomAlert: (message, alertType) => dispatch(setAlert(message, alertType))
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDACLogs);
